<!--tipos-cob.svelte-->
<script>
	import {onMount} from 'svelte'
	import {API, http_headers,acListCheck, getLoggedUser} from '../global.js'
	import Tiposcobform from './tipos-cob-form.svelte'

	let complejo = 0
	let tipocob = ''
	let cobs = []
	let update = false
	let openform = false

	export let formdata = {}

	$: fetchData = (async() => {

		/*let query = `select id,cobranza,tipocli,idmoneda,simbolo,cuotas,chcuotas,fpagotipo,fpagoname,coef1val,coef1lbl,coef1dsc,coef1col,observ,fecalta,fecbaja,interno,activo,idcomplejo,fpagodsc,orden,cotizado,permisos,estados from w_tipocob where 1=1`
		*/

		let query = `select * from w_tipocob where 1=1`
		
		if(parseInt(complejo)!==0){
			query += ` and idcomplejo=${complejo}`
		}
		if(tipocob!==''){
			query += ` and cobranza='${tipocob}'`
		}
		const res = await fetch(`${API}/exec-query?u=${update}`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		const data = await res.json()
		
		//console.log(data)
		if(res.ok) return data.data
		else throw new Error(data)
	})

	function editar(cb){
		formdata = cb
		openform = true
	}

	function close(){
		formdata = {}
		openform = false
	}

	onMount( async () => {
		let qry = `select distinct cobranza from w_tipocob`
		const res = await fetch(`${API}/exec-query`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query:qry})	
			})
		const data = await res.json()
		if(res.ok) cobs = data.data
		else throw new Error(data)
	})

</script>

{#if !openform}
<div class="container-fluid">

	{#if acListCheck('VER-TIPO-COB')}
		<div class="row">
			<div class="col-auto">
				<span class="btn btn-sm btn-dark" on:click={()=>update=!update}>!</span>
				<select name="" id="" bind:value={tipocob} class="px-4">
					<option value=""></option>
					{#each cobs as cb, index}
						<option value={cb.cobranza}>{cb.cobranza}</option>
					{/each}
				</select>
				<select name="" id="" bind:value={complejo} class="px-4">
					<option value="0"></option>
					<option value="1">RDA</option>
					<option value="2">RDE</option>
				</select>
			</div>
		</div>
		{#await fetchData()}
			<p>Loading....</p>
		{:then rs}
			
			<table class="table table-sm">
				<thead>
					<th>Id</th>
					<th>Cobranza</th>
					<th>Tipocli</th>
					<th>Idmoneda</th>
					<th>Simbolo</th>
					<th>Cuotas</th>
					<th>Chcuotas</th>
					<th>Fpagotipo</th>
					<th>Fpagoname</th>
					<th>Coef1val</th>
					<th>Coef1lbl</th>
					<th>Coef1dsc</th>
					<th>Coef1col</th>
					<!-- <th>Observ</th> -->
					<!-- <th>Fecalta</th> -->
					<th>Fecbaja</th>
					<th>Interno</th>
					<th>Activo</th>
					<th>Idcomplejo</th>
					<th>Fpagodsc</th>
					<th>Orden</th>
					<th>Cotizado</th>
					<!-- <th>Permisos</th> -->
					<!-- <th>Estados</th> -->
				</thead>
				<tbody>
					
					{#each rs as fp, index}
						<tr>
							<td on:click={()=>editar(fp)}>{fp.id}</td>
							<td>{fp.cobranza}</td>
							<td>{fp.tipocli}</td>
							<td>{fp.idmoneda}</td>
							<td>{fp.simbolo}</td>
							<td>{fp.cuotas}</td>
							<td>{fp.chcuotas}</td>
							<td>{fp.fpagotipo}</td>
							<td>{fp.fpagoname}</td>
							<td>{fp.coef1val}</td>
							<td>{fp.coef1lbl}</td>
							<td>{fp.coef1dsc}</td>
							<td>{fp.coef1col}</td>
							<!--td>{fp.observ}</td-->
							<!-- <td>{fp.fecalta}</td> -->
							<td>{(fp.fecbaja||'').substr(0,10)}</td>
							<td>{fp.interno}</td>
							<td>{fp.activo}</td>
							<td>{fp.idcomplejo}</td>
							<td>{fp.fpagodsc}</td>
							<td>{fp.orden}</td>
							<td>{fp.cotizado}</td>
							<!-- <td>{fp.permisos}</td> -->
							<!-- <td>{fp.estados}</td> -->
						</tr>
					{/each}
				</tbody>
			</table>
		{/await}

	{/if}	

</div>
{/if}

{#if openform}
	<div class="overlay"> 
		<div class="card mx-2 mt-4 border"  style="margin: 2vw auto;width:96vw;height:80vh;overflow: auto;">
			<div class="card-header">
		    	<button class="btn btn-danger btn-sm float-end" on:click={close}>&Cross;</button>
		    	<h5 class="card-title">Tipo cobranza {formdata.cobranza}</h5>
			</div>
			
		  	<Tiposcobform {formdata} />
		  	
		</div>
	</div>
{/if}
 	
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    